import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { TagSelector } from "../../../components/Taxonomy/TagSelector";
import { Stack } from "../../../styles/Containers";
import { StyledButton } from "../../../styles/matieralui/Button";
import { StyledA, StyledH6, StyledP } from "../../../styles/StyledHTML";
import { createGenericTag, searchGenericTags } from "../GenericTags/redux/generictags.actions";
import { FullGenericTags } from "../GenericTags/redux/generictags.selectors";
import { createLibrary, searchLibrary } from "../Library/redux/library.actions";
import { FullLibraries } from "../Library/redux/library.selectors";
import { createLocation, searchLocations } from "../Location/redux/locations.actions";
import { FullLocations } from "../Location/redux/locations.selectors";
import { createPerson, searchPeople } from "../People/redux/people.actions";
import { FullPeople } from "../People/redux/people.selectors";
import { Screen } from "../Photostream/Uploader";
export const OnboardingTags = ({ type = null, onComplete }) => {
    const dispatch = useDispatch();
    const store = FullGenericTags();
    const [items, setItems] = useState([]);


    useEffect(() => { if (store.createSuccess) onComplete(); }, [store.createLoading])
    useEffect(() => { dispatch(searchGenericTags(0, null, null, 'all', {})) }, [])
    useEffect(() => { if (store?.items?.count > 0) onComplete(); }, [store])

    const createItem = () => dispatch(createGenericTag({ name: items[0]?.name }));

    let heading = "Your First Tag";
    let description = "Tags are items that appear in photos. Tagging is the best way to make photos searchable. If you want to search on it later, add it as a tag. Let's make a new one now. You can add more while your uploading.";
    let examples = "Examples: Cup, Book, Field, Beach, Mountains";
    let label = "Enter a Tag Name";
    let defaults = [];

    // Church Content
    if (type == 'church') {
        heading = "Your First Tag";
        description = "Tags are items that appear in photos. Tagging is the best way to make photos searchable. If you want to search on it later, add it as a tag. Let's make a new one now. You can add more while your uploading.";
        examples = "Examples: Preaching, Worship, Stage, Easter, Christmas, Youth";
        label = "Enter a Tag Name";
        defaults = [{ name: 'Preaching' }, { name: 'Worship' }, { name: 'Stage' }, { name: 'Easter' }, { name: 'Christmas' }, { name: 'Youth' }, { name: 'Sunday Service' }]
    }

    return (
        <Screen>
            <Stack textAlign="center" maxWidth="600px">
                <StyledH6>{heading}</StyledH6>
                <StyledP>{description}</StyledP>
                <br />
                <StyledP light>{examples}</StyledP>


                <TagSelector
                    noLabels={true}
                    inputLabel={label}
                    existingOptions={items}
                    options={defaults}
                    onChange={(v) => setItems(v)}
                    limit={1}
                />


                <Stack width="100%" align="center" justify="center" thinking={store.createLoading}>
                    <StyledButton disabled={(items?.length < 1) ? true : false} variant="contained" color="blue" onClick={createItem}>Create</StyledButton>
                    <StyledP light small><StyledA onClick={onComplete}>skip</StyledA></StyledP>
                </Stack>

            </Stack>

        </Screen>
    )
}